import type React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface StreamData {
  id: number;
  booking: {
    id: number;
    deceased: Array<{
      first_name: string;
      second_name?: string;
      surname: string;
    }>;
    services?: Array<{
      venue?: {
        name: string;
      };
    }>;
  };
  date: string;
  address_one?: string;
  city?: string;
}

interface ServiceDeliveryNoteCardProps {
  stream?: StreamData;
}

const ServiceDeliveryNoteCard: React.FC<ServiceDeliveryNoteCardProps> = ({
  stream,
}) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/stream-management/view/${stream?.id}/service-delivery-note`);
  };

  return (
    <Card sx={{ boxShadow: 0, mt: 2 }}>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Service Delivery Note
          </Typography>

          <Tooltip title="View Service Delivery Note">
            <IconButton onClick={handleNavigate} color="primary">
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ServiceDeliveryNoteCard;
